<template>
  <div>
    <div id="print">
      <div>
        <span>
          <center><h3>绝当结算确认书</h3></center>
        </span>
      </div>
      <div class="contents">
        <span>
          当户：{{ LookData.name }}（证件号：{{ LookData.cardnumber }} 电话：{{
            LookData.telnumber
          }}）
        </span>
        <span
          >当票号:{{ LookData.ticketnumber }} 当物:{{ LookData.objname }} 重量:{{
            LookData.weight
          }}克
        </span>
        <span>典当金额:{{ LookData.price }}元</span>
        <span
          >典当期间（从建当{{ LookData.startdate }}至到期日{{ LookData.enddate }}止）
        </span>
        <span>
          典当天数{{ days }}天，累计已付典当综合费和利息合计：{{
            Number(zpri) + Number(LxPri)
          }}元,
        </span>
        <span> 绝当日期：{{ Jdates }} </span>
        <span>
          当业务构成违约绝当，动产典当综合费用和利息的日费息率计费不超过（4.2%+0.28%）/30天=0.149%
        </span>
        <span>
          本业务整个典当期间应产生典当综合费和利息：{{
            LookData.price * 0.00149 * (days + 5)
          }}元。
        </span>
        <span> 绝当日起至变卖绝当物清偿前，产生逾期费用按不足5日按5日费率计算。 </span>
        <span> 当票{{ LookData.ticketnumber }}号业务在{{ jDays }}起绝当。 </span>
      </div>
    </div>

    <div class="footers">
      <el-button type="primary" v-print="'#print'"> 打 印 </el-button>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "LookMsg",
  props: ["LookData"],
  data() {
    return {
      days: 0,
      SumPri: 0,
      zpri: 0,
      LxPri: 0,
      Jdates: "-",
      jDays: "",
    };
  },
  methods: {
    //计算综合费和利息总金额
    SumPris() {
      // this.LookData
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({ticketnumber:"${this.LookData.ticketnumber}"}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          for (let i = 0; i < res.data.data.length; i++) {
            //循环计算的综合费总金额
            this.zpri = this.Sum(res.data.data);

            //循环计算利息

            // console.log(this.SumLx(res.data.data))
          }

          let a = res.data.data.filter((re) => {
            return re.stas == "续当";
          });
          let newArr = [];
          for (let b = 0; b < a.length; b++) {
            // console.log(a[b].lx);

            newArr.push(a[b].lx);
          }
          this.LxPri = this.SumLx(newArr);

          let jDate = res.data.data.filter((item) => {
            return (item.stas = "绝当");
          });
          this.Jdates = jDate[0].xuday;
        });
    },
    Sum(arr) {
      //循环计算的总金额
      let str = "";
      for (let i in arr) {
        str += arr[i].xupri;
        str += "+";
      }
      str = str.substring(0, str.length - 1);

      return eval(str) || 0;
    },

    SumLx(arr) {
      //循环计算利息的总金额
      let str = "";
      for (let i in arr) {
        str += arr[i];
        str += "+";
      }
      str = str.substring(0, str.length - 1);

      return eval(str) || 0;
    },
    jDay() {
      this.jDays = dayjs(this.LookData.enddate).add(5, "day").format("YYYY-MM-DD");
    },
  },
  created() {
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.days =
        dayjs(this.LookData.enddate).diff(dayjs(this.LookData.startdate), "day") + 1;

      this.SumPris();
      this.jDay();
    }, 800);
  },
};
</script>
<style scoped>
.contents {
  display: flex;
  flex-direction: column;
}
.contents span {
  margin: 16px;
}
.footers {
  /* float: right; */
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
